import { Helmet } from "react-helmet";
import "../assets/css/style.css";
import { useEffect, useState } from "react";
import {
  useFetcher,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { getBlog } from "./../axios";

const SingleBlog = () => {
  const [currentBlog, setCurrentBlog] = useState({});
  const { title } = useParams();
  const originalTitle = title.replace(/-/g, " ");

  const location = useLocation();
  const navigate = useNavigate();

  // const slugify = (text) => {
  //   return text
  //     ?.trim()
  //     ?.replace(/\s*-\s*/g, "-") // Normalize dashes surrounded by spaces
  //     ?.replace(/\s+/g, "-") // Replace all remaining spaces with hyphens
  //     ?.replace(/-+/g, "-") // Collapse multiple hyphens
  //     ?.replace(/[^\u0600-\u06FF\w-]/g, "") // Remove non-Persian/Arabic/word chars except hyphens
  //     ?.toLowerCase();
  // };

  function cleanText(input) {
    return input
      .replace(/[^\p{L}\p{N}]+/gu, ' ') // Replace all non-letter/number with space
      .replace(/\s+/g, ' ')             // Replace multiple spaces with single space
      .trim();                          // Trim leading/trailing spaces
  }

  //blogs redirects
  useEffect(() => {
    if (
      location.pathname ===
        "/blog/%D8%A2%D8%B2%D9%85%D9%88%D9%86-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D8%AF%D9%88%D8%B1%D9%87-%DB%B5%DB%B2" ||
      location.pathname ===
        "/blog/%D8%A2%D8%B2%D9%85%D9%88%D9%86-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D8%AF%D9%88%D8%B1%D9%87-52---%D8%AA%D8%A7%D8%B1%DB%8C%D8%AE-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-1404" ||
      location.pathname ===
        "/blog/%D8%AF%D9%81%D8%AA%D8%B1%DA%86%D9%87-A-%D8%B3%D9%88%D8%A7%D9%84%D8%A7%D8%AA-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D8%AF%D9%88%D8%B1%D9%87-50-%DA%A9%D9%84%DB%8C%D8%AF" ||
      location.path ===
        "/blog/%D8%A2%D8%BA%D8%A7%D8%B2%20%D9%85%D8%AC%D9%85%D9%88%D8%B9%D9%87%20%DA%A9%D8%AA%D8%A7%D8%A8%E2%80%8C%D9%87%D8%A7%DB%8C%20%D8%A2%D8%AA%D8%B1%D9%88%D9%81%D8%B3%D8%AA:%20%D8%A8%D9%87%E2%80%8C%D8%B1%D9%88%D8%B2%D8%B1%D8%B3%D8%A7%D9%86%DB%8C%20%D8%AC%D8%AF%DB%8C%D8%AF%20%D8%AF%D8%B1%20%D8%A2%D9%85%D9%88%D8%B2%D8%B4%20%D8%A2%D8%B2%D9%85%D9%88%D9%86%20%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C" ||
      location.path ===
        "/blog/%D8%A2%D8%BA%D8%A7%D8%B2-%D9%85%D8%AC%D9%85%D9%88%D8%B9%D9%87-%DA%A9%D8%AA%D8%A7%D8%A8%E2%80%8C%D9%87%D8%A7%DB%8C-%D8%A2%D8%AA%D8%B1%D9%88%D9%81%D8%B3%D8%AA:-%D8%A8%D9%87%E2%80%8C%D8%B1%D9%88%D8%B2%D8%B1%D8%B3%D8%A7%D9%86%DB%8C-%D8%AC%D8%AF%DB%8C%D8%AF-%D8%AF%D8%B1-%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D8%A2%D8%B2%D9%85%D9%88%D9%86-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C" || location.path === "/blog/%D8%A7%D9%86%D8%AA%D8%AE%D8%A7%D8%A8-%D8%B1%D8%B4%D8%AA%D9%87-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D9%86%DA%A9%D8%A7%D8%AA%DB%8C-%DA%A9%D9%87-%D9%82%D8%A8%D9%84-%D8%A7%D8%B2-%D8%A7%D9%86%D8%AA%D8%AE%D8%A7%D8%A8-%D8%A8%D8%A7%DB%8C%D8%AF-%D8%AF%D8%B1-%D9%86%D8%B8%D8%B1-%D8%A8%DA%AF%DB%8C%D8%B1%DB%8C%D8%AF" || location.path === "/blog/%D8%A7%D9%86%D8%AA%D8%AE%D8%A7%D8%A8-%D8%B1%D8%B4%D8%AA%D9%87-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D8%AF%D8%B1-%D9%85%D9%88%D8%B1%D8%AF-%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87-%D8%A8%D9%82%DB%8C%D9%87-%D8%A7%D9%84%D9%84%D9%87-%DA%86%D9%82%D8%AF%D8%B1-%D9%85%DB%8C-%D8%AF%D9%88%D9%86%DB%8C%D8%AF%D8%9F" || location.path === "/blog/%D8%A7%D9%86%D8%AA%D8%AE%D8%A7%D8%A8-%D8%B1%D8%B4%D8%AA%D9%87-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D8%AD%D9%88%D8%A7%D8%B3%D8%AA%D9%88%D9%86-%D8%A8%D8%A7%D8%B4%D9%87-%DA%AF%D8%B1%D9%81%D8%AA%D8%A7%D8%B1-%D8%B3%DB%8C%DA%A9%D9%84-%D9%85%D8%B9%DB%8C%D9%88%D8%A8-%D9%86%D8%B4%DB%8C%D8%AF"
    ) {
      navigate("/", { replace: true });
    } else if (
      location.pathname ===
      "/blog/%D8%AB%D8%A8%D8%AA-%D9%86%D8%A7%D9%85-%D8%A2%D8%B2%D9%85%D9%88%D9%86-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%DB%B1%DB%B4%DB%B0%DB%B3"
    ) {
      navigate(
        "/blog/%D8%AB%D8%A8%D8%AA-%D9%86%D8%A7%D9%85-%D8%A2%D8%B2%D9%85%D9%88%D9%86-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D9%BE%D8%B2%D8%B4%DA%A9%DB%8C-%DB%B1%DB%B4%DB%B0%DB%B3",
        { replace: true }
      );
    } else if (
      location.pathname ===
      "/blog/%D8%A7%D9%86%D8%AA%D8%AE%D8%A7%D8%A8-%D8%B1%D8%B4%D8%AA%D9%87-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C-%D8%B6%D8%B1%D9%88%D8%B1%D8%AA-%D8%AA%D8%AD%D9%82%DB%8C%D9%82%D8%A7%D8%AA-%DA%A9%D8%A7%D9%85%D9%84-%D9%82%D8%A8%D9%84-%D8%A7%D8%B2-%D8%A7%D9%86%D8%AA%D8%AE%D8%A7%D8%A8-%D8%B1%D8%B4%D8%AA%D9%87-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C"
    ) {
      navigate(
        "/blog/%D8%A2%D8%B2%D9%85%D9%88%D9%86-%D8%AF%D8%B3%D8%AA%DB%8C%D8%A7%D8%B1%DB%8C",
        { replace: true }
      );
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await getBlog();
      if (data) {
        const blogClicked = data.find((item) => cleanText(item?.title) === cleanText(title));
        if (blogClicked) setCurrentBlog(blogClicked);
      }
    };

    fetchData();
  }, [title]);

  //setting the title back to آتروپین when user exit the component
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    return () => {
      document.title = "آتروپین - مشاوره آزمون دستیاری - منابع آزمون دستیاری";
    };
  }, []);

console.log(currentBlog.img);


  return (
    <div className="container">
      <div className="row">
        {currentBlog.meta && (
          <Helmet>
            <title>آتروپین - {currentBlog.title}</title>
            <meta name="description" content={currentBlog.meta} />
            {/* Add more meta tags as needed */}
          </Helmet>
        )}
        <img
          src={currentBlog.img}
          alt="content_image"
          className="col-12 col-sm-8  mx-auto my-4"
          style={{ maxHeight: "500px", objectFit: "contain" }}
        />
        <p>
          عنوان:
          <span className="ml-4" style={{ fontWeight: "800" }}>
            {currentBlog.title}
          </span>
        </p>

        {/* <div class="h_iframe-aparat_embed_frame"><span style={{display: "block",paddingTop: "58%"}}></span><iframe src="https://www.aparat.com/video/video/embed/videohash/gmbuh4r/vt/frame"  allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe></div> */}
        <ol>
          {currentBlog.blogfile1 && (
            <li>
              <a
                className="text-primary btn btn-outline btn-sm border rounded px-4 my-1 ml-2 "
                href={currentBlog.blogfile1}
                donwnload
                target="_blank"
                rel="noopener noreferrer"
              >
                فایل 1
              </a>
            </li>
          )}
          {currentBlog.blogfile2 && (
            <li>
              <a
                className="text-primary btn btn-outline btn-sm border rounded px-4 my-1 ml-2 "
                href={currentBlog.blogfile2}
                donwnload
                target="_blank"
                rel="noopener noreferrer"
              >
                فایل 2
              </a>
            </li>
          )}
          {currentBlog.blogfile3 && (
            <li>
              <a
                className="text-primary btn btn-outline btn-sm border rounded px-4 my-1 ml-2 "
                href={currentBlog.blogfile3}
                donwnload
                target="_blank"
                rel="noopener noreferrer"
              >
                فایل 3
              </a>
            </li>
          )}
        </ol>
        {currentBlog?.text?.includes("<") ? (
          <div dangerouslySetInnerHTML={{ __html: currentBlog.text }}></div>
        ) : (
          <p style={{ whiteSpace: "pre-line" }}>{currentBlog.text}</p>
        )}
      </div>
    </div>
  );
};

export default SingleBlog;
